import { stringify, parse } from "qs";

/*
 * 获取实时预览的新地址
 * 地址都要带上preivew 参数
 * @param {*} href eg: /cart?sku=abc&color=blue
 * @param {*} previewCode 
 * @returns eg: /cart?sku=abc&color=blue&preview=123
 */
export function getPreviewUrl(href, previewCode) {
  if (!previewCode) return href

  const hrefArr = href.split('?');

  const url = hrefArr[0];
  const search = hrefArr?.[1] || null;

  if (!search) {
    return `${url}?preview=${previewCode}`;
  }

  // url参转换成对象
  const params = parse(search);
  params.preview = previewCode;

  // 转换成url字符串
  const string = stringify(params);

  return `${url}?${string}`;
}

/*
 * 获取图片的宽高
 * 图片可能格式 https://xx-xx.com/xxx-370x256.png
 */
export function imageWidthHeight(url) {
  const arr = url.split('-');
  const sizeStr = arr[arr.length - 1];

  if (sizeStr.includes('x') && sizeStr.includes('.')) {
    const a = sizeStr.split('.');
    if (a.length !== 2) {
      return null;
    }

    const size = a[0].split('x');

    const width = parseInt(size[0], 10);
    const height = parseInt(size[1], 10);

    if (Number.isNaN(width) || Number.isNaN(height)) {
      return null
    }

    return {
      height,
      width
    }
  }

  return null
}

/**
 * 实时预览模式下链接拦截并转发
 * @param {*} previewCode 
 */
export function previewLinkObserver(previewCode) {
  if (window.Jq) {
    // 监听a标签的点击事件
    Jq('html').on('click', 'a', (e) => {
      // 获取a标签的href
      const href = Jq(e.currentTarget).attr('href');
      if (!href) return;
      // 跳转后默认置顶
      const newHref = decodeURIComponent(getPreviewUrl(href, previewCode)).replace(/#.*/,'#');

      Jq(e.currentTarget).attr('href', newHref)
    })

    // 表单提交
    Jq("form[action]").each((index, item) => {
      // 追加子元素
      const length = Jq(item).find("input[name='preview']")?.length || 0;
      if (length == 0) {
        Jq(item).append(`<input name="preview" style="display: none" value='${previewCode.replace(/#.*/,'')}' />`)
      }
    });
  }

  // 修改window.open
  const Wopen = window.open;
  window.open = (url, target) => {
    const newUrl = getPreviewUrl(url, previewCode)

    Wopen(newUrl, target)
  }
}

/**
 * 获取url的某个参数
 * @param {*} name 
 * @returns 
 */
export function getUrlParam(name, location = null) {
  const params = getRequestParams(location);

  return params?.[name] || null
}

/**
 * 获取 url params参数
 * @returns 
 */
export function getRequestParams(location = null) {
  const url = location || window.location?.href
  const search = url.split('?')?.[1] || null

  if (!search) return null;

  const params = parse(search)

  return params;
}

/**
 * url 转url参数
 * eq http://test.com/test?a=132&b=456
 * return {
 *   path: 'http://test.com/test',
 *   query: {
 *    a: 123,
 *    b: 456
 *   }
 * }
 * */
export function urlToQueryData(url) {
  const arr = url.split('?');
  const path = arr[0];
  const query = arr?.[1] ? parse(arr[1]) : {}

  const pathNameArr = path.split('/')

  const pathName = pathNameArr[pathNameArr?.length - 1];
  return {
    path,
    pathName,
    query
  }
}

/**
 * query参数转url
 * eq {
 *  path: 'http://test.com/test',
 *  query: {
 *    a: 123,
 *    b: 456
 *  }
 * }
 * return http://test.com/test?a=123&b=456
 */
export function quertDataToUrl(data) {
  const { path, query } = data;
  if (!path) return null;

  if (!query || typeof query !== 'object') return path

  const str = stringify(query)

  if (!str) return path

  return `${path}?${str}`
}

/**
 * 播放和暂停视频
 * 原生video
 * video dom 视频元素
 * status 1, 播放，0 停止播放
 * */
export function playVideo(video, status) {
  const videoType = video.localName
  const videoUrl = video.getAttribute('video-src')

  if (!videoUrl) return

  // 普通视频
  if (videoType === 'video') {
    if (status === 1) {
      video.setAttribute('src', videoUrl)
      video.setAttribute('autoplay', true)
      video?.play()
    } else {
      video?.pause()
    }
  }
  // YouTube视频
  if (videoType === 'iframe') {
    // 暂停播放
    const params = urlToQueryData(videoUrl)

    params.query.autoplay = status
    params.query.mute = 1 // 静音播放
    const newUrl = quertDataToUrl(params)

    video.setAttribute('src', newUrl)
  }
};

export default {
  imageWidthHeight
}
